const GlobalLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/20 backdrop-blur-[1px]">
      {}
      <div className="relative w-56 h-[3px] overflow-hidden rounded-full bg-slate-200">
        <div className="absolute inset-y-0 w-1/3 rounded-full bg-gradient-to-r from-blue-600 via-indigo-500 to-emerald-500 animate-fintech-line" />
      </div>
      {}
      <p className="mt-3 text-[11px] tracking-[0.25em] text-slate-700 font-medium animate-pulse">
        SECURE FAST PAY
      </p>
    </div>
  );
};
export default GlobalLoader;
